import { NotesApi } from 'further-types/notes';
import Note from './Note';
import { UseMutationResult } from '@tanstack/react-query';
import Heading from 'components/Heading';

interface NoteGroupProps {
  notes: Array<NotesApi.NoteResponse>;
  title: string;
  linkOnLastNote?: boolean;
  deleteNote: UseMutationResult<boolean, Error, string>;
}

const NoteGroup: React.FC<NoteGroupProps> = ({
  notes,
  title,
  linkOnLastNote,
  deleteNote,
}) => {
  return (
    <>
      <Heading variant="h2" noMargin>
        {title}
      </Heading>
      {notes.map((note, i) => (
        <Note
          key={note._id}
          note={note}
          link={i !== notes.length - 1 || linkOnLastNote}
          deleteNote={deleteNote}
        />
      ))}
    </>
  );
};

export default NoteGroup;
